import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Form = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 10px;
`;
